import { render, staticRenderFns } from "./eod-job-types-config.vue?vue&type=template&id=66515578&scoped=true"
import script from "./eod-job-types-config.vue?vue&type=script&lang=js"
export * from "./eod-job-types-config.vue?vue&type=script&lang=js"
import style0 from "./eod-job-types-config.vue?vue&type=style&index=0&id=66515578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66515578",
  null
  
)

export default component.exports